export default {
  addItem: {
    position: 'fixed',
    right: 200,
    top: 35,
    zIndex: 1100,
  },
  noDataRow: {
    textAlign: 'center',
    color: 'lightgrey',
    fontSize: 24,
  },
  noData: {
    fontSize: 250,
    color: 'lightgrey',
  },
  chip: {
    marginRight: 3,
    marginBottom: 2,
    marginTop: 2,
  },
  chipLabelStyle: {
  },
  nameCol: {
    width: 180,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  mobileCol: {
    width: 150,
  },
  emailCol: {
    // width: 250,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  permissionCol: {
    width: 200,
  },
  permissions: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  tagCol: {
    width: 200,
  },
  tags: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  actionCol: {
    width: 130,
  },
  wrapper: {
    marginTop: 20,
    marginBottom: 80,
  },
};



// WEBPACK FOOTER //
// ./src/components/Employees/styles.js